import { createSlice } from "@reduxjs/toolkit";
const initialLesseeState = {
  lessee: {
    contracts: {
      data: [],
      loading: false,
      error: null,
    },
    listPendingInvoices: {
      data: [],
      loading: false,
      error: null,
    },
  },
};

const lesseeSlice = createSlice({
  name: "lessee",
  initialState: initialLesseeState,
  reducers: {
    loadListPendingInvoices(state, action) {
      state.lessee.listPendingInvoices.data = action.payload;
    },
    startLoadingListPendingInvoices(state) {
      state.lessee.listPendingInvoices.error = null;
      state.lessee.listPendingInvoices.loading = true;
    },
    stopLoadingListPendingInvoices(state) {
      state.lessee.listPendingInvoices.loading = false;
    },
    errorListPendingInvoices(state, action) {
      state.lessee.listPendingInvoices.error = action.payload;
    },
  },
});

export const lesseeActions = lesseeSlice.actions;

export default lesseeSlice.reducer;
